export default "/_next/static/images/new-user-notification-17a9729f7301a567d6207b50d651364e.png";